import i18n from '@/app/i18n';

import { isNetworkError } from './errors';

/**
 * Файл, который ученик прикрепляет в чате куратору (05.10.2026, сборка 1.1.1 по шнуру; решение техлида — вариант А).
 *
 * 🔴 ЧТО БЫЛО. Чат ученика с 24.08.2026 слал файл в категорию `lesson_media`, а files-service пускает в неё только
 * сотрудников (`admin`, `manager`, `curator`): любой файл ученика получал 403, на экран шло «role not permitted for
 * this category». И на сайте, и в приложении.
 *
 * Категория `homework` ученику разрешена, типы те же (картинки, аудио, видео, PDF), предел размера общий. Сверено
 * чтением 05.10.2026: загрузка не рождает сдачу домашки (files-service событий не шлёт, его таблицу никто не читает —
 * сдачи живут в progress), файлы раздаются по ключу публично — куратор откроет. Своя категория чата — техдолг
 * (вариант Б): службе нужна правка, а приложению это ждать незачем.
 */
export const CHAT_ATTACH_CATEGORY = 'homework';

/**
 * Почему файл не прикрепился — словами для ученика. Текст сервера (английский) не показываем никогда.
 */
export function chatAttachError(err: unknown): string {
  if (isNetworkError(err)) return i18n.t('errors.network');
  const status = (err as { status?: number } | null)?.status;
  if (status === 413) return i18n.t('chat.attachTooBig');
  if (status === 415) return i18n.t('chat.attachType');
  return i18n.t('chat.attachFailed');
}
